/**
 * A supplemental-feed URL as Meta must fetch it. Local dev returns a relative
 * path (no public API origin configured) — prefix the API base the app itself
 * talks to.
 */
export const absoluteFeedUrl = (url: string): string =>
  url.startsWith("http")
    ? url
    : `${(import.meta.env.VITE_API_BASE_URL || window.location.origin).replace(/\/$/, "")}${url}`
